import { render, staticRenderFns } from "./sign-up-form.html?vue&type=template&id=2ef2dbd2&scoped=true&"
import script from "./sign-up-form.js?vue&type=script&lang=js&"
export * from "./sign-up-form.js?vue&type=script&lang=js&"
import style0 from "./SignUpForm.vue?vue&type=style&index=0&id=2ef2dbd2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef2dbd2",
  null
  
)

component.options.__file = "SignUpForm.vue"
export default component.exports